import React from 'react';
import { Button } from './ui/Button';
import { ScrollReveal } from './ui/ScrollReveal';
export function FinalStatementSection() {
  return <section className="relative w-full bg-charcoal flex items-center justify-center px-6 md:px-12 py-24 md:py-32 overflow-hidden" data-id="element-59">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-chocolate/20 via-charcoal to-charcoal" data-id="element-60"></div>

      <div className="relative z-10 text-center max-w-5xl" data-id="element-61">
        <ScrollReveal data-id="element-62">
          <h2 className="text-5xl md:text-7xl lg:text-[100px] font-bold text-white mb-6 tracking-tight leading-none" data-id="element-63">
            EXPERIENCE
            <br data-id="element-64" />
            GLENLOFTY
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-65">
          <p className="text-xl md:text-3xl text-gold font-light mb-16 tracking-wide" data-id="element-66">
            Visit our estate in the heart of the Pyrenees
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.4} data-id="element-67">
          <div className="flex flex-col md:flex-row gap-6 justify-center items-center" data-id="element-68">
            <Button variant="secondary" size="lg" className="w-full md:w-auto" data-id="element-69">
              Contact
            </Button>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}